// extracted by mini-css-extract-plugin
export default {"box":"cancellationFilterPage_box__5bKej","box__content":"cancellationFilterPage_box__content__SzKHP"};